import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface CurrentUser {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_superuser: boolean;
  tenant_id: string | null;
  branch_id: string | null;
  branch_name: string | null;
  home_branch_id: string | null;
  locale: string;
  density: string;
  theme: string;
  // Role names removed in GYM-55: per-request RBAC resolves dynamically; the
  // frontend hydrates effective permissions from /users/me/permissions/.
  // ``role_ids`` lists the user's TenantRole UUIDs for "show me my role
  // assignments" UX (e.g. settings/users/me showing chips).
  role_ids: string[];
  currency: string;
  /** Company setting: show the "send from your own WhatsApp" buttons. */
  whatsapp_manual_send_enabled?: boolean;
}

interface AuthState {
  access: string | null;
  refresh: string | null;
  user: CurrentUser | null;
  setTokens: (tokens: { access: string; refresh: string }) => void;
  setUser: (user: CurrentUser | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      access: null,
      refresh: null,
      user: null,
      setTokens: ({ access, refresh }) => set({ access, refresh }),
      setUser: (user) => set({ user }),
      clear: () => set({ access: null, refresh: null, user: null }),
    }),
    { name: "gymviz.auth" },
  ),
);
